import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WindowWrapperService {

  get href(): string {
    return window.location.href;
  }

  set href(
    href: string
  ) {
    window.location.href = href;
  }

  get origin(): string {
    return window.location.origin;
  }

  get pathname(): string {
    return window.location.pathname;
  }

}
